import { render, staticRenderFns } from "./ConfigurationCardComponent.vue?vue&type=template&id=616b628c&scoped=true"
import script from "./ConfigurationCardComponent.vue?vue&type=script&lang=js"
export * from "./ConfigurationCardComponent.vue?vue&type=script&lang=js"
import style0 from "./ConfigurationCardComponent.vue?vue&type=style&index=0&id=616b628c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616b628c",
  null
  
)

export default component.exports